<div [ngClass]="{'card-border':isCard}" class="Flexbox flex-wrap-wrap full-width">
  <div *ngFor="let keyValue of displayedData" class="aberration-extra-detail" [style.width]="(100 / columns) + '%'">
    <span class="extra-detail-column extra-detail-key" translate>{{translationPrefix + '.' + getKey(keyValue.name)}}</span>
    <div [ngSwitch]="getKeyConfig(keyValue.name).valueType">
      <div *ngSwitchCase="'color-text'">
        <color-text
          [config]="getKeyConfig(keyValue.name).config"
          [text]="keyValue.value"
        ></color-text>
      </div>
      <div *ngSwitchCase="'standard'">
        <span *ngIf="!keyValue.url && keyValue.name !== 'COSMIC ID'" class="extra-detail-column extra-detail-val">{{keyValue.value}}</span>
        <a target="_blank" title="{{keyValue.value}}" *ngIf="keyValue.url" href="{{keyValue.value}}" class="extra-detail-val extra-detail-val-link">{{getLinkName(keyValue)}}</a>
        <span *ngIf="keyValue.name === 'COSMIC ID' && !cosmOrCosn(keyValue.value)" class="extra-detail-column extra-detail-val">{{keyValue.value}}</span>
        <a target="_blank" *ngIf="keyValue.name === 'COSMIC ID' && cosmOrCosn(keyValue.value)" href="{{cosmicURL(keyValue.value,keyValue.stableCosmicId)}}" class="extra-detail-column extra-detail-val-link">{{keyValue.value}}</a>
      </div>
    </div>
  </div>
</div>
